import React, { useState, useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from '@bingads-webui-react/fabric-with-signal';
import { TooltipHost, DirectionalHint } from '@fluentui/react';
import { withPreference } from '@bingads-webui-react/preference-context';
import { StateStore } from '@bingads-webui/state-store';
import { useId } from '@fluentui/react-hooks';
import { Scenario, Activity, ActivityContext } from '@bingads-webui-react/hoc-with-signal';
import { setClarityTag } from '@bingads-webui-universal/clarity';

export const ONBOARDING_PREFERENCE = 'UseNewCampaignsGoalsSelection';

export const isNewOnboardingVisibleStore = new StateStore({
  isNewOnboardingVisible: true,
});

const calloutProps = { gapSpace: 0 };

const hostStyles = { root: { display: 'inline-block', height: '30px' } };

const OnboardingToggleInternal = ({
  i18n,
  preferenceService,
  defaultState,
}) => {
  const [checked, setChecked] = useState(defaultState);
  const tooltipId = useId('tooltip');

  const activity = useContext(ActivityContext);

  const onChange = (e, toggleCheck) => {
    // trigger survey if the toggle is off
    if (!toggleCheck) {
      window.survey.switchBackToOldCampaignOnboarding = true;
      window.survey.surveyManager.trigger();

      setClarityTag({ switchBackToOldCampaignOnboarding: true });
      // logic to switch off the pilot is in the survey submit callback
    } else {
      // if enabling do not block the user.
      setChecked(toggleCheck);
      setClarityTag({ switchBackToOldCampaignOnboarding: false });
    }
    preferenceService.setAtUserLevel({
      Name: ONBOARDING_PREFERENCE,
      Data: toggleCheck,
    });
  };

  useEffect(() => {
    isNewOnboardingVisibleStore.setState({
      isNewOnboardingVisible: checked,
    });
  }, [checked]);

  useEffect(() => {
    if (activity) {
      activity.signal(`onOnboardingToggleChange - ${checked}`);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TooltipHost
      content={i18n.getString(_TL_('You can turn off the toggle to use the former campaign creation experience if you\'d like more time to adapt. Please note that after Feb 28th we will only support the new layout'))}
        // This id is used on the tooltip itself, not the host
        // (so an element with this id only exists when the tooltip is shown)
      id={tooltipId}
      calloutProps={calloutProps}
      styles={hostStyles}
      directionalHint={DirectionalHint.bottomCenter}
    >
      <Toggle
        label={i18n.getString(_TL_('New campaign creation experience'))}
        inlineLabel
        onChange={onChange}
        checked={checked}
      />
    </TooltipHost>

  );
};

OnboardingToggleInternal.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  preferenceService: PropTypes.shape({
    findByNameAtUserLevel: PropTypes.func.isRequired,
    setAtUserLevel: PropTypes.func.isRequired,
  }).isRequired,
  defaultState: PropTypes.bool.isRequired,
};

const OnBoardingToggleWithActivity = props => (
  <Scenario name="CampaignOnboardingToggleSwitch">
    <Activity name="ToggleSwitch">
      <OnboardingToggleInternal {...props} />
    </Activity>
  </Scenario>
);

export const OnboardingToggle = withPreference(OnBoardingToggleWithActivity);
